<template>
  <div class="login">
    <div class="login__card panel">
      <div class="login__brand">
        <img class="login__logo" :src="logoUrl" alt="Idoing" width="40" height="40" />
        <div>
          <h1 class="login__title">登录 Idoing</h1>
          <p class="login__sub">与主站同一账号体系 · 登录后可用调试台与控制台</p>
        </div>
      </div>

      <div class="login__tabs" role="tablist">
        <button
          v-for="t in tabs"
          :key="t.id"
          type="button"
          role="tab"
          class="login__tab"
          :class="{ 'is-active': mode === t.id }"
          @click="mode = t.id"
        >
          {{ t.label }}
        </button>
      </div>

      <!-- 手机验证码 -->
      <form v-if="mode === 'phone'" class="login__form" @submit.prevent="onPhoneLogin">
        <label class="field">
          <span>手机号</span>
          <input v-model="phone" type="tel" maxlength="11" placeholder="请输入手机号" autocomplete="tel" />
        </label>
        <label class="field">
          <span>验证码</span>
          <div class="field__row">
            <input
              v-model="phoneCode"
              type="text"
              maxlength="6"
              placeholder="6 位验证码"
              autocomplete="one-time-code"
            />
            <button
              type="button"
              class="btn btn-ghost"
              :disabled="phoneCd > 0 || sending"
              @click="onSendPhoneCode"
            >
              {{ phoneCd > 0 ? phoneCd + 's' : '获取验证码' }}
            </button>
          </div>
        </label>
        <label class="login__remember">
          <input v-model="rememberMe" type="checkbox" />
          记住登录状态
        </label>
        <button type="submit" class="btn btn-primary login__submit" :disabled="loading">
          {{ loading ? '登录中…' : '登录 / 注册' }}
        </button>
      </form>

      <!-- 密码 -->
      <form v-else-if="mode === 'password'" class="login__form" @submit.prevent="onPasswordLogin">
        <label class="field">
          <span>手机号 / 账号 / 邮箱</span>
          <input v-model="account" type="text" placeholder="请输入账号" autocomplete="username" />
        </label>
        <label class="field">
          <span>密码</span>
          <input
            v-model="password"
            type="password"
            placeholder="请输入密码"
            autocomplete="current-password"
          />
        </label>
        <label class="login__remember">
          <input v-model="rememberMe" type="checkbox" />
          记住登录状态
        </label>
        <button type="submit" class="btn btn-primary login__submit" :disabled="loading">
          {{ loading ? '登录中…' : '登录' }}
        </button>
      </form>

      <!-- 邮箱验证码 -->
      <form v-else class="login__form" @submit.prevent="onEmailLogin">
        <label class="field">
          <span>邮箱</span>
          <input v-model="email" type="email" placeholder="请输入邮箱" autocomplete="email" />
        </label>
        <label class="field">
          <span>验证码</span>
          <div class="field__row">
            <input
              v-model="emailCode"
              type="text"
              maxlength="6"
              placeholder="6 位验证码"
              autocomplete="one-time-code"
            />
            <button
              type="button"
              class="btn btn-ghost"
              :disabled="emailCd > 0 || sending"
              @click="onSendEmailCode"
            >
              {{ emailCd > 0 ? emailCd + 's' : '获取验证码' }}
            </button>
          </div>
        </label>
        <label class="login__remember">
          <input v-model="rememberMe" type="checkbox" />
          记住登录状态
        </label>
        <button type="submit" class="btn btn-primary login__submit" :disabled="loading">
          {{ loading ? '登录中…' : '登录 / 注册' }}
        </button>
      </form>

      <!-- <p class="login__apis mono">
        POST /login/phone-code · /login/email-code<br />
        POST /login/app/with-phone-code · with-password · with-email-code
      </p> -->
    </div>
  </div>
</template>

<script>
import {
  sendPhoneCode,
  sendEmailCode,
  loginWithPhoneCode,
  loginWithPassword,
  loginWithEmailCode
} from '../utils/loginApi'
import { saveAuth, getRememberMeDefault, isLoggedIn } from '../utils/auth'
import { showErrorToast, showSuccessToast } from '../utils/toast'
import { BRAND_LOGO_URL } from '../utils/brand'

const PHONE_RE = /^1[3-9]\d{9}$/
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export default {
  name: 'Login',
  data() {
    return {
      logoUrl: BRAND_LOGO_URL,
      tabs: [
        // { id: 'phone', label: '验证码登录' },
        // { id: 'password', label: '密码登录' },
        { id: 'email', label: '邮箱验证码' }
      ],
      mode: 'email',
      phone: '',
      phoneCode: '',
      account: '',
      password: '',
      email: '',
      emailCode: '',
      rememberMe: getRememberMeDefault(),
      loading: false,
      sending: false,
      phoneCd: 0,
      emailCd: 0,
      phoneTimer: null,
      emailTimer: null
    }
  },
  created() {
    if (isLoggedIn()) {
      this.goNext()
    }
  },
  beforeDestroy() {
    if (this.phoneTimer) clearInterval(this.phoneTimer)
    if (this.emailTimer) clearInterval(this.emailTimer)
  },
  methods: {
    goNext() {
      const redirect = (this.$route.query.redirect && String(this.$route.query.redirect)) || '/playground'
      this.$router.replace(redirect.startsWith('/') ? redirect : '/' + redirect)
    },
    startCd(kind, seconds) {
      if (kind === 'phone') {
        if (this.phoneTimer) clearInterval(this.phoneTimer)
        this.phoneCd = seconds
        this.phoneTimer = setInterval(() => {
          this.phoneCd--
          if (this.phoneCd <= 0) {
            clearInterval(this.phoneTimer)
            this.phoneTimer = null
          }
        }, 1000)
      } else {
        if (this.emailTimer) clearInterval(this.emailTimer)
        this.emailCd = seconds
        this.emailTimer = setInterval(() => {
          this.emailCd--
          if (this.emailCd <= 0) {
            clearInterval(this.emailTimer)
            this.emailTimer = null
          }
        }, 1000)
      }
    },
    pickError(err, fallback) {
      return (
        (err && err.response && err.response.data && (err.response.data.message || err.response.data.error)) ||
        (err && err.message) ||
        fallback
      )
    },
    applyLoginRes(res) {
      const data = res && res.data ? res.data : res
      if (!data || !data.token) {
        showErrorToast((res && (res.error || res.message)) || '登录失败')
        return false
      }
      saveAuth({
        token: data.token,
        user: data.user || null,
        rememberMe: this.rememberMe
      })
      showSuccessToast(data.is_first_login ? '注册并登录成功' : '登录成功')
      this.goNext()
      return true
    },
    async onSendPhoneCode() {
      if (!PHONE_RE.test(this.phone)) {
        showErrorToast('请输入正确的手机号')
        return
      }
      if (this.sending || this.phoneCd > 0) return
      this.sending = true
      try {
        const res = await sendPhoneCode(this.phone)
        if (res && (res.success || res.data !== undefined || !res.error)) {
          showSuccessToast('验证码已发送')
          this.startCd('phone', 60)
        } else {
          showErrorToast((res && (res.error || res.message)) || '发送失败')
        }
      } catch (e) {
        showErrorToast(this.pickError(e, '发送失败'))
      } finally {
        this.sending = false
      }
    },
    async onPhoneLogin() {
      if (!PHONE_RE.test(this.phone)) {
        showErrorToast('请输入正确的手机号')
        return
      }
      if (!this.phoneCode || String(this.phoneCode).length !== 6) {
        showErrorToast('请输入 6 位验证码')
        return
      }
      this.loading = true
      try {
        const res = await loginWithPhoneCode(this.phone, this.phoneCode)
        this.applyLoginRes(res)
      } catch (e) {
        showErrorToast(this.pickError(e, '登录失败'))
      } finally {
        this.loading = false
      }
    },
    async onPasswordLogin() {
      const account = String(this.account || '').trim()
      const password = String(this.password || '')
      if (!account) {
        showErrorToast('请输入账号')
        return
      }
      if (!password) {
        showErrorToast('请输入密码')
        return
      }
      let payload
      if (PHONE_RE.test(account)) payload = { phone: account, password }
      else if (EMAIL_RE.test(account)) payload = { email: account, password }
      else payload = { account, password }

      this.loading = true
      try {
        const res = await loginWithPassword(payload)
        this.applyLoginRes(res)
      } catch (e) {
        showErrorToast(this.pickError(e, '登录失败'))
      } finally {
        this.loading = false
      }
    },
    async onSendEmailCode() {
      const email = String(this.email || '').trim()
      if (!EMAIL_RE.test(email)) {
        showErrorToast('请输入有效邮箱')
        return
      }
      if (this.sending || this.emailCd > 0) return
      this.sending = true
      try {
        const res = await sendEmailCode(email)
        if (res && (res.success || (res.data && !res.error) || !res.error)) {
          showSuccessToast('验证码已发送到邮箱')
          this.startCd('email', 60)
        } else {
          showErrorToast((res && (res.error || res.message)) || '发送失败')
        }
      } catch (e) {
        showErrorToast(this.pickError(e, '发送失败'))
      } finally {
        this.sending = false
      }
    },
    async onEmailLogin() {
      const email = String(this.email || '').trim()
      if (!EMAIL_RE.test(email)) {
        showErrorToast('请输入有效邮箱')
        return
      }
      if (!this.emailCode || String(this.emailCode).length !== 6) {
        showErrorToast('请输入 6 位验证码')
        return
      }
      this.loading = true
      try {
        const res = await loginWithEmailCode(email, this.emailCode)
        this.applyLoginRes(res)
      } catch (e) {
        showErrorToast(this.pickError(e, '登录失败'))
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login {
  min-height: calc(100vh - 160px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px 48px;
}
.login__card {
  width: 100%;
  max-width: 440px;
  padding: 28px 24px 22px;
}
.login__brand {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  margin-bottom: 22px;
}
.login__logo {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  flex-shrink: 0;
  object-fit: contain;
  background: #0a0a0a;
  display: block;
}
.login__title {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.03em;
}
.login__sub {
  margin: 6px 0 0;
  font-size: 13px;
  color: var(--muted);
  line-height: 1.45;
}
.login__tabs {
  display: flex;
  gap: 4px;
  padding: 4px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  margin-bottom: 18px;
}
.login__tab {
  flex: 1;
  border: 0;
  background: transparent;
  color: var(--muted);
  font-size: 12px;
  font-weight: 600;
  padding: 9px 6px;
  border-radius: 9px;
  cursor: pointer;
}
.login__tab.is-active {
  color: var(--text);
  background: rgba(125, 255, 179, 0.12);
}
.login__form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  color: var(--muted);
}
.field input {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 11px 12px;
  background: rgba(0, 0, 0, 0.25);
  color: var(--text);
  font-size: 14px;
}
.field__row {
  display: flex;
  gap: 8px;
}
.field__row input {
  flex: 1;
}
.field__row .btn {
  flex-shrink: 0;
  white-space: nowrap;
}
.login__remember {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--muted);
  user-select: none;
}
.login__submit {
  width: 100%;
  justify-content: center;
  margin-top: 4px;
  padding: 12px;
}
.login__apis {
  margin: 18px 0 0;
  font-size: 10px;
  line-height: 1.6;
  color: var(--muted);
  opacity: 0.75;
}
</style>
